import { ChangeDetectorRef, Component, computed, inject, Inject, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Splash } from "../../../Akte/Controlls/Splash";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { DomSanitizer } from "@angular/platform-browser";


@Component({
  imports: [
    CommonModule,
    Splash,
    FormsModule
  ],
  selector: 'AktePopup',
  templateUrl: './AktePopup.html',
  standalone: true,
  styleUrl: './AktePopup.css'
})
export class AktePopup implements OnInit {

  ngOnInit(): void {
 
  }
  modal = inject(NgbActiveModal);
  constructor(private cdr: ChangeDetectorRef, protected sanitizer: DomSanitizer) {
   
  }
  @Input() Key?: number | null = null;
  @Input() versichertenNr?: string | null = null;


  url = computed(() => this.sanitizer.bypassSecurityTrustResourceUrl(this.versichertenNr ? this.Key ? `/Akte/${this.versichertenNr}/${this.Key}` : `/Akte/${this.versichertenNr}` : `/Akte`));
}
